import Vue from "vue";

import GcDescriptionCodeCellTemplate from "./gc-grid-description-code-cell-template";
import GcAdvanceFilterPanel from "./gc-advance-filter-panel";
import GcAutoCompleteItemTemplate from "./gc-autocomplete-item-template";
import GcEditDeliveryAddress from "./gc-edit-delivery-address";

import GcGridValueFormat from "./gc-grid-value-format-template";
import GcBranchAutoComplete from "./gc-branch-auto-complete";
import GcFriendlyDate from "./gc-friendly-date";
import GcSupplierAutoComplete from "./gc-supplier-auto-complete";
import GcStatusActive from "./gc-friendly-active";
import GcGridDeliveryAddressSelection from "./gc-grid-delivery-address-selection";
import GcGridProductImage from "./gc-grid-product-image";
import GcNumberPlusMinus from "./gc-number-plus-minus";
import GcSalesContractProductDetails from "./gc-sales-contract-product-details.vue";
import GcSalesUmDropdown from "./gc-sales-um-dropdown";
import GcAdvanceFilterPanelV2 from "./gc-advance-filter-panel-v2";
import GcFooterValue from "./gc-footer-value";

export function RegisterV1BaseComponents() {
  // eslint-disable-next-line no-console
  // this.$logger.debug("Registering devexpress components globally");
  Vue.component("GcBranchAutoComplete", GcBranchAutoComplete);
  Vue.component("GcFriendlyDate", GcFriendlyDate);
  Vue.component("GcSupplierAutoComplete", GcSupplierAutoComplete);
  Vue.component("GcStatusActive", GcStatusActive);

  Vue.component(
    "GcGridDeliveryAddressSelection",
    GcGridDeliveryAddressSelection
  );
  Vue.component("GcGridProductImage", GcGridProductImage);
  Vue.component("GcNumberPlusMinus", GcNumberPlusMinus);
  Vue.component("GcSalesContractProductDetails", GcSalesContractProductDetails);
  Vue.component("GcSalesUmDropdown", GcSalesUmDropdown);

  Vue.component("GcDescriptionCodeCellTemplate", GcDescriptionCodeCellTemplate);
  Vue.component("GcAdvanceFilterPanel", GcAdvanceFilterPanel);
  Vue.component("GcAutoCompleteItemTemplate", GcAutoCompleteItemTemplate);
  Vue.component("GcEditDeliveryAddress", GcEditDeliveryAddress);
  Vue.component("GcGridValueFormat", GcGridValueFormat);
  Vue.component("GcAdvanceFilterPanelV2", GcAdvanceFilterPanelV2);
  Vue.component("GcFooterValue", GcFooterValue);
}

import GridHelper from "../_helpers/dev-express/grid-helper";
GridHelper.initialise();
